// import { tns } from "../build/tiny-slider/tiny-slider";
// 
// var slider = tns({
// 	container: '.my-slider',
// 	loop: true,
// 	autoplay: true,
// 	autoplayHoverPause: true,
// 	autoplayButtonOutput: false,
// 	controls: false,
// 	nav: false,
// 	speed: 2000,
// 	autoplayTimeout: 0,
// 	preventActionWhenRunning: true,
// 	mouseDrag: true,
// 	responsive: {
// 		640: {
// 			items: 2
// 		},
// 		700: {
// 			items: 3
// 		},
// 		900: {
// 			items: 4
// 		},
// 		1140: {
// 			items: 5
// 		}
// 	}
// });


/*! Image Map Resizer (imageMapResizer.min.js ) - v1.0.10 - 2019-04-10
 *  Desc: Resize HTML imageMap to scaled image.
 *  Copyright: (c) 2019 David J. Bradshaw - dave@bradshaw.net
 *  License: MIT
 */

!function(){"use strict";function r(){function e(){var r={width:u.width/u.naturalWidth,height:u.height/u.naturalHeight},a={width:parseInt(window.getComputedStyle(u,null).getPropertyValue("padding-left"),10),height:parseInt(window.getComputedStyle(u,null).getPropertyValue("padding-top"),10)};i.forEach(function(e,t){var n=0;o[t].coords=e.split(",").map(function(e){var t=1==(n=1-n)?"width":"height";return a[t]+Math.floor(Number(e)*r[t])}).join(",")})}function t(e){return e.coords.replace(/ *, */g,",").replace(/ +/g,",")}function n(){clearTimeout(d),d=setTimeout(e,250)}function r(e){return document.querySelector('img[usemap="'+e+'"]')}var a=this,o=null,i=null,u=null,d=null;"function"!=typeof a._resize?(o=a.getElementsByTagName("area"),i=Array.prototype.map.call(o,t),u=r("#"+a.name)||r(a.name),a._resize=e,u.addEventListener("load",e,!1),window.addEventListener("focus",e,!1),window.addEventListener("resize",n,!1),window.addEventListener("readystatechange",e,!1),document.addEventListener("fullscreenchange",e,!1),u.width===u.naturalWidth&&u.height===u.naturalHeight||e()):a._resize()}function e(){function t(e){e&&(!function(e){if(!e.tagName)throw new TypeError("Object is not a valid DOM element");if("MAP"!==e.tagName.toUpperCase())throw new TypeError("Expected <MAP> tag, found <"+e.tagName+">.")}(e),r.call(e),n.push(e))}var n;return function(e){switch(n=[],typeof e){case"undefined":case"string":Array.prototype.forEach.call(document.querySelectorAll(e||"map"),t);break;case"object":t(e);break;default:throw new TypeError("Unexpected data type ("+typeof e+").")}return n}}"function"==typeof define&&define.amd?define([],e):"object"==typeof module&&"object"==typeof module.exports?module.exports=e():window.imageMapResize=e(),"jQuery"in window&&(window.jQuery.fn.imageMapResize=function(){return this.filter("map").each(r).end()})}();
//# sourceMappingURL=imageMapResizer.map



/*!
 * hoverIntent v1.10.2 // 2020.04.28 // jQuery v1.7.0+
 * http://briancherne.github.io/jquery-hoverIntent/
 *
 * You may use hoverIntent under the terms of the MIT license. Basically that
 * means you are free to use hoverIntent as long as this header is left intact.
 * Copyright 2007-2019 Brian Cherne
 */
!function(factory){"use strict";"function"==typeof define&&define.amd?define(["jquery"],factory):"object"==typeof module&&module.exports?module.exports=factory(require("jquery")):jQuery&&!jQuery.fn.hoverIntent&&factory(jQuery)}(function($){"use strict";function track(ev){cX=ev.pageX,cY=ev.pageY}function isFunction(value){return"function"==typeof value}var cX,cY,_cfg={interval:100,sensitivity:6,timeout:0},INSTANCE_COUNT=0,compare=function(ev,$el,s,cfg){if(Math.sqrt((s.pX-cX)*(s.pX-cX)+(s.pY-cY)*(s.pY-cY))<cfg.sensitivity)return $el.off(s.event,track),delete s.timeoutId,s.isActive=!0,ev.pageX=cX,ev.pageY=cY,delete s.pX,delete s.pY,cfg.over.apply($el[0],[ev]);s.pX=cX,s.pY=cY,s.timeoutId=setTimeout(function(){compare(ev,$el,s,cfg)},cfg.interval)};$.fn.hoverIntent=function(handlerIn,handlerOut,selector){var instanceId=INSTANCE_COUNT++,cfg=$.extend({},_cfg);$.isPlainObject(handlerIn)?(cfg=$.extend(cfg,handlerIn),isFunction(cfg.out)||(cfg.out=cfg.over)):cfg=isFunction(handlerOut)?$.extend(cfg,{over:handlerIn,out:handlerOut,selector:selector}):$.extend(cfg,{over:handlerIn,out:handlerIn,selector:handlerOut});function handleHover(e){var ev=$.extend({},e),$el=$(this),hoverIntentData=$el.data("hoverIntent");hoverIntentData||$el.data("hoverIntent",hoverIntentData={});var state=hoverIntentData[instanceId];state||(hoverIntentData[instanceId]=state={id:instanceId}),state.timeoutId&&(state.timeoutId=clearTimeout(state.timeoutId));var mousemove=state.event="mousemove.hoverIntent.hoverIntent"+instanceId;if("mouseenter"===e.type){if(state.isActive)return;state.pX=ev.pageX,state.pY=ev.pageY,$el.off(mousemove,track).on(mousemove,track),state.timeoutId=setTimeout(function(){compare(ev,$el,state,cfg)},cfg.interval)}else{if(!state.isActive)return;$el.off(mousemove,track),state.timeoutId=setTimeout(function(){!function(ev,$el,s,out){var data=$el.data("hoverIntent");data&&delete data[s.id],out.apply($el[0],[ev])}(ev,$el,state,cfg.out)},cfg.timeout)}}return this.on({"mouseenter.hoverIntent":handleHover,"mouseleave.hoverIntent":handleHover},cfg.selector)}});



// Add your custom JS here.

AOS.init();





jQuery(document).ready(function($){
	
	// Benefits Toggle on Click
	
	$('.wp-custom-benefits.detailed .toggle-on-click .icon-left, .wp-custom-benefits.detailed .toggle-on-click h3').click(function(){
		var container = $(this).closest('.toggle-on-click');
		
		if( container.hasClass('expanded') ){
			// Collapse
			$(this).closest('.toggle-on-click').removeClass('expanded');
		} else {
			// Expand
			$(this).closest('.toggle-on-click').addClass('expanded');
		}
		
	});
	
	
	
	// How it works - Image Map
	
	$('map[name=image-map]').imageMapResize();
	
	$('map[name=image-map] area')
		.mouseenter(function(e){
			
			var container = $(this).closest('.how-it-works-imagemap');
			
			// Show
			container.find('.' + $(this).attr('data-box')).addClass('visible');
			
		})
		.mouseleave(function(e){
			
			var container = $(this).closest('.how-it-works-imagemap');
			
			// Hide
			container.find('.box').removeClass('visible');
			
		})
	;
	
	
	// Pricing table
	$('.pricing-table .header').click(function(){
		var accordion = $( $(this).attr('data-target') );
	
		if( accordion.css('display') == 'none' ){
			$(this).addClass('expanded');
			accordion.slideDown();
		} else {
			$(this).removeClass('expanded');
			accordion.slideUp();
		}
	});
	
	
	// GTanslate
	
	$('.translator .close').click(function(){
		$(this).closest('.translator').remove();
	});
	
	
	// Yoast FAQ Toggle
	$('.wp-block-yoast-faq-block .schema-faq-question').click(function(){
		var section = $(this).closest('.schema-faq-section');
		
		// Collapse
		if( section.hasClass('expanded') ){
			section.removeClass('expanded');
			section.find('.schema-faq-answer').slideUp();
			
		// Expand
		} else {
			section.addClass('expanded');
			section.find('.schema-faq-answer').slideDown();
		}
		
	});
	
});